module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "music-wrapper"
  }, [_c('scroll', {
    ref: "scroll",
    attrs: {
      "pullup": true
    },
    on: {
      "scrollToEnd": function($event) {
        _vm.end()
      }
    }
  }, [_c('ul', {
    staticClass: "music"
  }, [_c('usersub'), _vm._v(" "), _c('sheet', {
    ref: "sheet",
    attrs: {
      "scroll": _vm.scrollComponent
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-01adf40e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/view/music.vue
// module id = 192
// module chunks = 1